// Chapter numbers follow professional-market-report-v4.json (current v6 contract).
const topics = [['04', '目标客群'], ['06', '核心卖点'], ['12', '内容与验证计划']]
export function reportStrategy(report) {
  const chapters = report?.chapters || report?.full_report_sections || []
  return topics.map(([number, label]) => {
    const chapter = chapters.find(item => String(item.no).padStart(2, '0') === number)
    const candidates = [chapter?.conclusion, chapter?.summary, ...(chapter?.paragraphs || []),
      ...(chapter?.actions || []), ...(chapter?.points || []).map(point => typeof point === 'string' ? point : point.body)]
    const text = candidates.find(value => typeof value === 'string' && value.trim()) || ''
    return { number, label, title: chapter?.title || '', text, caveat: chapter?.caveat || '' }
  })
}
